var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"follow"},[_c('div',[_vm._v("扫码关注公众号并收藏产品方便下次购买！")]),_c('img',{attrs:{"src":_vm.followUrl}})]),_c('div',{staticClass:"continue",on:{"click":_vm.continueBuy}},[_vm._v("继续购买")])])}
var staticRenderFns = []

export { render, staticRenderFns }